import {CanDeactivateGuard} from './../shared/can-deactivate.guard';
import {ManageSubscriptionsComponent} from './manage-subscriptions.component';
import {AdsModule} from './../adcomponents/ad.module';
import {SharedModule} from './../shared/shared.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ManageSubscriptionsRoutingModule} from './manage-subscriptions-routing.module';
import {NgProgressModule} from 'ngx-progressbar';
import {NgxPaginationModule} from 'ngx-pagination';
import {ManageSubscriptionProgramsComponent} from './manage-subscription-programs/manage-subscription-programs.component';
import {ManageSubscriptionOrdersComponent} from './manage-subscription-programs/manage-subscription-orders/manage-subscription-orders.component';
import {ManageService} from '../services/manage.service';
import {SharedService} from './shared/shared.service';
import {ManageAdkdetailsComponent} from './manage-adkdetails/manage-adkdetails.component';
import {ManageAnnuitiesComponent} from './manage-annuities/manage-annuities.component';
import {MatSortModule} from '@angular/material/sort';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {ManageCspDetailsComponent} from './manage-cspdetails/manage-cspdetails.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ManageSubscriptiondetailsComponent} from './manage-subscriptiondetails/manage-subscriptiondetails.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {CspFilterPipe} from '../shared/pipes/csp-filter.pipe';
import {SubscriptionItemsComponent} from './shared/subscription-items/subscription-items.component';
import {DialogService} from '../services/dialog.service';
import {CreateEndUserComponent} from './manage-annuities/create-end-user/create-end-user.component';
import {AssociateExistingEndUserComponent} from './manage-annuities/associate-existing-end-user/associate-existing-end-user.component';
import {MicrosoftCloudAgreementComponent} from '../popup-collection/microsoft-cloud-agreement/microsoft-cloud-agreement.component';
import {EditEndUserDetailComponent} from './manage-cspdetails/edit-end-user-detail/edit-end-user-detail.component';
import {AddSubscriptionsComponent} from './manage-cspdetails/add-subscriptions/add-subscriptions.component';
import {AddPerpetualComponent} from './manage-cspdetails/add-perpetual/add-perpetual.component';
import {AddAzureRiComponent} from './manage-cspdetails/add-azure-ri/add-azure-ri.component';
import {SelectAzureRiComponent} from './manage-cspdetails/add-azure-ri/select-azure-ri/select-azure-ri.component';
import {AddSoftwareComponent} from './manage-cspdetails/add-software/add-software.component';


import {CspAddonFilterPipe} from '../shared/pipes/csp-addon-filter.pipe';
import {AddAddonComponent} from './manage-cspdetails/add-addon/add-addon.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {PendingChangesGuard} from '../shared/pending-changes-guard.guard';
import {AddAdkSubscriptionComponent} from './manage-adkdetails/add-adk-subscription/add-adk-subscription.component';
import {ConfirmSplaOrderComponent} from '../popup-collection/confirm-spla-order/confirm-spla-order.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {EditPaymentDetailComponent} from './manage-cspdetails/edit-payment-detail/edit-payment-detail.component';

import {EditADKPaymentComponent} from './manage-adkdetails/edit-adk-payment/edit-adk-payment.component';
import {AddProductsComponent} from '../manage-subscriptions/manage-cspdetails/add-product/add-product.component';
import {ConfirmProductsComponent} from '../manage-subscriptions/manage-cspdetails/add-product/confirm-product/confirm-product.component';
import {SubscriptionPaymentDetail} from './shared/subscription-payment-detail/subscription-payment-detail.component';
import {SubscriptionEditPayment} from './shared/subscription-edit-payment/subscription-edit-payment.component';
import {ConfigurePortalManagement} from './manage-cspdetails/configure-portal-management/configure-portal-management.component';
import {ConfigureEndUserComponent} from './manage-annuities/configure-end-user/configure-end-user.component';
import {ManageSPLAComponent} from './programs/SPLA/manage-spla.component';
import {AddIsvSubscriptionsComponent} from './programs/ISV/manage-isvdetails/add-isv-subscriptions/add-isv-subscriptions.component';
import {ManageIsvdetailsComponent} from './programs/ISV/manage-isvdetails/manage-isvdetails.component';
import {ManageISVComponent} from './programs/ISV/manage-isv.component';
import {ManageCitrixCSPComponent} from './programs/CitrixCSP/manage-citrixcsp.component';
import {ManageCitrixCSPdetailsComponent} from './programs/CitrixCSP/manage-citrixcspdetails/manage-citrixcspdetails.component';
import {AddCitrixCSPSubscriptionsComponent} from './programs/CitrixCSP/manage-citrixcspdetails/add-citrixcsp-subscriptions/add-citrixcsp-subscriptions.component';
import {ManageTeleSmartComponent} from './programs/TELE/manage-tele.component';
import {AddTeleSmartSubscriptionsComponent} from './programs/TELE/manage-teledetails/add-tele-subscriptions/add-tele-subscriptions.component';
import {ManageTeleSmartdetailsComponent} from './programs/TELE/manage-teledetails/manage-teledetails.component';
import {ManageINTAComponent} from './programs/INTA/manage-inta.component';
import {ManageINTAdetailsComponent} from './programs/INTA/manage-intadetails/manage-intadetails.component';
import {AddINTASubscriptionsComponent} from './programs/INTA/manage-intadetails/add-inta-subscriptions/add-inta-subscriptions.component';
import {ManageWiiseComponent} from './programs/WIISE/manage-wiise.component';
import {ManageWiisedetailsComponent} from './programs/WIISE/manage-wiisedetails/manage-wiisedetails.component';
import {AddWiiseSubscriptionsComponent} from './programs/WIISE/manage-wiisedetails/add-wiise-subscriptions/add-wiise-subscriptions.component';
import {ManageCISCOSAASComponent} from './programs/CISCOSAAS/manage-ciscosaas.component';
import {ManageCISCOSAASdetailsComponent} from './programs/CISCOSAAS/manage-ciscosaasdetails/manage-ciscosaasdetails.component';
import {AddCISCOSAASSubscriptionsComponent} from './programs/CISCOSAAS/manage-ciscosaasdetails/add-ciscosaas-subscriptions/add-ciscosaas-subscriptions.component';
import {ManageCISCOComponent} from './programs/CISCOMSP/manage-ciscomsp.component';
import {AddCISCOSubscriptionsComponent} from './programs/CISCOMSP/manage-ciscomspdetails/add-ciscomsp-subscriptions/add-ciscomsp-subscriptions.component';
import {ManageCISCOdetailsComponent} from './programs/CISCOMSP/manage-ciscomspdetails/manage-ciscomspdetails.component';
import {ManageTMMSPComponent} from './programs/TMMSP/manage-tmmsp.component';
import {ManageTMMSPdetailsComponent} from './programs/TMMSP/manage-tmmspdetails/manage-tmmspdetails.component';
import {AddTMMSPSubscriptionsComponent} from './programs/TMMSP/manage-tmmspdetails/add-tmmsp-subscriptions/add-tmmsp-subscriptions.component';
import {ManageStorageCraftCComponent} from './programs/SC/manage-sc.component';
import {ManageStorageCraftdetailsComponent} from './programs/SC/manage-scdetails/manage-scdetails.component';
import {AddStorageCraftSubscriptionsComponent} from './programs/SC/manage-scdetails/add-sc-subscriptions/add-sc-subscriptions.component';
import {SplaEditPayment} from './shared/spla-edit-payment/spla-edit-payment.component';
import {AddSplaSubscriptionsComponent} from './manage-spladetails/add-spla-subscriptions/add-spla-subscriptions.component';
import {ManageSpladetailsComponent} from './manage-spladetails/manage-spladetails.component';
import {AddSPLASubscriptionsComponent} from './programs/SPLA/manage-spladetails/add-spla-subscriptions/add-spla-subscriptions.component';
import {ManageSPLAdetailsComponent} from './programs/SPLA/manage-spladetails/manage-spladetails.component';
import {ManageKASPComponent} from './programs/KASP/manage-kasp.component';
import {ManageKaspDetailsComponent} from './programs/KASP/manage-kasp-details/manage-kasp-details.component';
import {AddKaspSubscriptionComponent} from './programs/KASP/manage-kasp-details/add-kasp-subscription/add-kasp-subscription.component';
import {EditKaspEndUserComponent} from './programs/KASP/manage-kasp-details/edit-kasp-end-user/edit-kasp-end-user.component';
import {CreateKaspEndUserComponent} from './programs/KASP/create-kasp-end-user/create-kasp-end-user.component';
import {EditKASPPaymentComponent} from './programs/KASP/manage-kasp-details/edit-kasp-payment/edit-kasp-payment.component';

import {ManageCirrusComponent} from './programs/CIRRUS/manage-cirrus.component';
import {ManageCirrusDetailsComponent} from './programs/CIRRUS/manage-cirrus-details/manage-cirrus-details.component';
import {AddCirrusSubscriptionComponent} from './programs/CIRRUS/manage-cirrus-details/add-cirrus-subscription/add-cirrus-subscription.component';
import {EditCirrusEndUserComponent} from './programs/CIRRUS/manage-cirrus-details/edit-cirrus-end-user/edit-cirrus-end-user.component';
import {CreateCirrusEndUserComponent} from './programs/CIRRUS/create-cirrus-end-user/create-cirrus-end-user.component';
import {EditCirrusPaymentComponent} from './programs/CIRRUS/manage-cirrus-details/edit-cirrus-payment/edit-cirrus-payment.component';



import {ColorPickerModule} from 'ngx-color-picker';
import {NgxDropzoneModule} from 'ngx-dropzone';
import {AddDigitalWalletComponent} from './shared/add-digital-wallet/add-digital-wallet.component';

import {MatExpansionModule} from '@angular/material/expansion';
import { ProgramDigitalWalletComponent } from './programs/program-digital-wallet/program-digital-wallet.component';
import { ProgramAddDigitalWalletComponent } from './programs/program-add-digital-wallet/program-add-digital-wallet.component';
import { ChildHeaderModule } from '../child-header/child-header.module';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatGridListModule} from '@angular/material/grid-list';
import { MatButtonModule } from '@angular/material/button';
import { TablefilterMultiplePipe } from '../shared/pipes/tablefilter-multiple.pipe';
import { ModalPopupModule } from '../shared/modal-popup/modal-popup.module';
import { BreadcrumbModule } from '../breadcrumb/breadcumb.module';
import { MatTableModule } from '@angular/material/table';
// import {CspSubscriptionComponent} from './shared/csp-subscription/csp-subscription.component';
import { ManageLicenseSubscriptionComponent } from './manage-cspdetails/manage-license-subscription/manage-license-subscription.component';
import { ManageAzureSubscriptionComponent } from './manage-cspdetails/manage-azure-subscription/manage-azure-subscription.component';
import { ConfirmUpgradeComponent } from './manage-cspdetails/manage-license-subscription/confirm-upgrade/confirm-upgrade.component';
import { CspTransitionSkuPipe } from '../shared/pipes/sku-pipe';
import { MatSidenavModule } from '@angular/material/sidenav';
import { PortalModule } from '@angular/cdk/portal';
import { MatBadgeModule } from '@angular/material/badge';
import { MatDividerModule } from '@angular/material/divider';
import { BudgetAndAlertsComponent } from './manage-cspdetails/manage-azure-subscription/budget-and-alerts/budget-and-alerts.component';
import { BudgetAndAlertsDetailsComponent } from './manage-cspdetails/manage-azure-subscription/budget-and-alerts/budget-and-alerts-details/budget-and-alerts-details.component';
import { BudgetAndAlertsEditComponent } from './manage-cspdetails/manage-azure-subscription/budget-and-alerts/budget-and-alerts-edit/budget-and-alerts-edit.component';
import { MatListModule } from '@angular/material/list';
import { MASSubscriptionsComponent } from './manage-cspdetails/manage-azure-subscription/mas-subscriptions/mas-subscriptions.component';
import { CSPEndUserDetailsComponent } from './manage-cspdetails/csp-end-user-details/csp-end-user-detail.component';
import { ManageReservedInstanceComponent } from './manage-cspdetails/manage-reserved-instance/manage-reserved-instance.component';
import { CSPTenantManagementComponent } from './manage-cspdetails/csp-tenant-management/csp-tenant-management.component';
import { CSPEndUserPortalManagementComponent } from './manage-cspdetails/csp-end-user-portal-management/csp-end-user-portal-management.component';
import { CSPLicenseSubscriptionComponent } from './manage-cspdetails/csp-license-subscription/csp-license-subscription.component';
// import { ManageWatchGuardsComponent } from './manage-watchguards/manage-watchguards.component';
import { CreateWatcGuardContractComponent } from './manage-watchguards/create-watchguard-contract/create-watchguard-contract.component';
import { ManageWGSEndUserComponent } from './manage-watchguards/manage-wgs-end-user/manage-wgs-end-user.component';
import { WGSEndUserDetailsEditComponent } from './manage-watchguards/manage-wgs-end-user/wgs-end-user-details-edit/wgs-end-user-details-edit.component';
import { ConfirmWGSProductsComponent } from './manage-watchguards/manage-wgs-end-user/add-product/confirm-wgs-product/confirm-wgs-product.component';
import { ManageWatchguardSubscriptionComponent } from './manage-watchguards/manage-wgs-end-user/manage-watchguard-subscription/manage-watchguard-subscription.component';
import { AddWGSProductsComponent } from './manage-watchguards/manage-wgs-end-user/add-product/add-wgs-product.component';
import { WGSTenantManagementComponent } from './manage-watchguards/manage-wgs-end-user/wgs-tenant-management/wgs-tenant-management.component';
import { BulkAssociateComponent } from './manage-annuities/bulk-associate/bulk-associate.component';
import {ManageSKReadOnlyComponent} from './manage-skreadonlydetails/manage-skreadonlydetails.component';
import { CreateAMPResellerComponent } from './manage-adobe-marketplace/create-amp-reseller/create-amp-reseller.component';
import { CreateAMPCustomerComponent } from './manage-adobe-marketplace/create-amp-customer/create-amp-customer.component';
import { ManageAMPCustomerComponent } from './manage-adobe-marketplace/manage-amp-customer/manage-amp-customer.component';
import { BulkOrderComponent } from './manage-annuities/bulk-order/bulk-order.component';
import { AMPCustomerDetailsComponent } from './manage-adobe-marketplace/manage-amp-customer/amp-customer-detail/amp-customer-detail.component';
import { WGSEndUserDetailsComponent } from './manage-watchguards/manage-wgs-end-user/wgs-end-user-details/wgs-end-user-detail.component';
import { AMPCustomerDetailsEditComponent } from './manage-adobe-marketplace/manage-amp-customer/amp-customer-details-edit/amp-customer-details-edit.component';
import { AdobeService } from '../services/adobe.service';
import { ManageAMPSubscriptionComponent } from './manage-adobe-marketplace/manage-amp-customer/manage-amp-subscription/manage-amp-subscription.component';
import { AssociateAdobeCustomerComponent } from './manage-annuities/associate-adobe-customer/associate-adobe-customer.component';
import { AddAMPProductsComponent } from './manage-adobe-marketplace/manage-amp-customer/add-amp-product/add-amp-product.component';
import { ConfirmAMPProductsComponent } from './manage-adobe-marketplace/manage-amp-customer/add-amp-product/confirm-amp-product/confirm-amp-product.component';
import { AMPSubscriptionCancellationComponent } from './manage-adobe-marketplace/manage-amp-customer/manage-amp-subscription/amp-subscription-cancellation/amp-subscription-cancellation.component';
import { AMPResellerEditComponent } from './manage-adobe-marketplace/amp-reseller-edit/amp-reseller-edit.component';
import { VIPMarketPlaceMigrationsComponent } from './manage-annuities/vip-market-place-migrations/vip-market-place-migrations.component';
import { AddAMPProductsV2Component } from './manage-adobe-marketplace/manage-amp-customer/add-amp-product/add-amp-product-v2.component';
import { ManageAMPSubscriptionScheduledComponent } from './manage-adobe-marketplace/manage-amp-customer/manage-amp-subscription-scheduled/manage-amp-subscription-scheduled.component';
import { VIPMarketPlaceBulkMigrationsComponent } from './manage-annuities/vip-market-place-bulk-migrations/vip-market-place-bulk-migrations.component';
import { ConfirmRenewalComponent } from './manage-cspdetails/manage-license-subscription/confirm-renewal/confirm-renewal.component';
import { ManageAMPConsumableComponent } from './manage-adobe-marketplace/manage-amp-customer/manage-amp-consumable/manage-amp-consumable.component';
import { RenewAMPProductsComponent } from './manage-adobe-marketplace/manage-amp-customer/add-amp-product/renew-amp-product/renew-amp-product.component';
import { RenewAMPProductsHGOComponent } from './manage-adobe-marketplace/manage-amp-customer/add-amp-product/renew-amp-product-hgo/renew-amp-product-hgo.component';
import { MatRadioModule } from '@angular/material/radio';
import { ViewHighGrowthOffersComponent } from './manage-adobe-marketplace/manage-amp-customer/add-amp-product/view-high-growth-offers/view-high-growth-offers.component';
import { ConfirmProductsV2Component } from './manage-cspdetails/add-product/confirm-product-v2/confirm-product-v2.component';
import { BulkTransferComponent } from './manage-annuities/bulk-transfer/bulk-transfer.component';
import { AMPEditPaymentDetailComponent } from './manage-adobe-marketplace/manage-amp-customer/amp-edit-payment-detail/amp-edit-payment-detail.component';

@NgModule({
  imports: [
    CommonModule,
    ManageSubscriptionsRoutingModule,
    NgProgressModule,
    NgbModule,
    NgxPaginationModule,
    FormsModule,
    SharedModule,
    AdsModule,
    MatSortModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatTabsModule,
    MatTableModule,
    MatSortModule,
    MatOptionModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    MatIconModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatRadioModule,
    MatTooltipModule,
    MatProgressBarModule,
    MatGridListModule,
    NgSelectModule,
    MatProgressSpinnerModule,
    MatExpansionModule,
    ColorPickerModule,
    NgxDropzoneModule,
    ChildHeaderModule,
    BreadcrumbModule,
    MatButtonModule,
    ModalPopupModule,
    MatSidenavModule,
    PortalModule,
    MatBadgeModule,
    MatDividerModule,
    MatListModule,
    MatNativeDateModule,
    MatDatepickerModule
  ],

  declarations: [
    ManageSubscriptionProgramsComponent,
    ManageSubscriptionsComponent,
    ManageSubscriptionOrdersComponent,
    ManageAdkdetailsComponent,
    ManageAnnuitiesComponent,
    ManageCspDetailsComponent,
    ManageWGSEndUserComponent,
    ManageSKReadOnlyComponent,
    ManageAMPCustomerComponent,
    // ManageWatchGuardsComponent,
    ManageSpladetailsComponent,
    CspFilterPipe,
    CspAddonFilterPipe,
    ManageSubscriptiondetailsComponent,
    SubscriptionItemsComponent,
    CreateEndUserComponent,
    CreateWatcGuardContractComponent,
    CreateAMPCustomerComponent,
    CreateAMPResellerComponent,
    AssociateExistingEndUserComponent,
    AssociateAdobeCustomerComponent,
    VIPMarketPlaceMigrationsComponent,
    EditEndUserDetailComponent,
    WGSEndUserDetailsEditComponent,
    AMPCustomerDetailsEditComponent,
    AMPResellerEditComponent,
    EditPaymentDetailComponent,
    AMPEditPaymentDetailComponent,
    AddSubscriptionsComponent,
    AddPerpetualComponent,
    AddAzureRiComponent,
    AddProductsComponent,
    AddWGSProductsComponent,
    AddAMPProductsComponent,
    AddAMPProductsV2Component,
    SelectAzureRiComponent,
    AddSoftwareComponent,
    BulkAssociateComponent,
    BulkOrderComponent,
    VIPMarketPlaceBulkMigrationsComponent,
    EditADKPaymentComponent,
    AddAddonComponent,
    AddSplaSubscriptionsComponent,
    AddAdkSubscriptionComponent,
    ConfirmProductsComponent,
    ConfirmProductsV2Component,
    ConfirmWGSProductsComponent,
    ConfirmAMPProductsComponent,
    RenewAMPProductsComponent,
    ViewHighGrowthOffersComponent,
    RenewAMPProductsHGOComponent,
    SubscriptionPaymentDetail,
    SubscriptionEditPayment,
    ConfigurePortalManagement,
    ConfigureEndUserComponent,
    //Programs
    ManageSPLAComponent,
    ManageSPLAdetailsComponent,
    AddSPLASubscriptionsComponent,

    ManageISVComponent,
    ManageIsvdetailsComponent,
    AddIsvSubscriptionsComponent,

    ManageCitrixCSPComponent,
    ManageCitrixCSPdetailsComponent,
    AddCitrixCSPSubscriptionsComponent,

    ManageTeleSmartComponent,
    ManageTeleSmartdetailsComponent,
    AddTeleSmartSubscriptionsComponent,

    ManageINTAComponent,
    ManageINTAdetailsComponent,
    AddINTASubscriptionsComponent,

    ManageWiiseComponent,
    ManageWiisedetailsComponent,
    AddWiiseSubscriptionsComponent,

    ManageCISCOSAASComponent,
    ManageCISCOSAASdetailsComponent,
    AddCISCOSAASSubscriptionsComponent,


    ManageCISCOComponent,
    ManageCISCOdetailsComponent,
    AddCISCOSubscriptionsComponent,


    ManageTMMSPComponent,
    ManageTMMSPdetailsComponent,
    AddTMMSPSubscriptionsComponent,

    ManageStorageCraftCComponent,
    ManageStorageCraftdetailsComponent,
    AddStorageCraftSubscriptionsComponent,

    ManageKASPComponent,
    ManageKaspDetailsComponent,
    EditKaspEndUserComponent,
    CreateKaspEndUserComponent,
    EditKASPPaymentComponent,
    AddKaspSubscriptionComponent,
    SplaEditPayment,
    AddDigitalWalletComponent,
    ProgramDigitalWalletComponent,
    ProgramAddDigitalWalletComponent,
    ConfirmSplaOrderComponent,
    ManageLicenseSubscriptionComponent,
    ManageWatchguardSubscriptionComponent,
    ManageAMPSubscriptionComponent,
    ManageAMPConsumableComponent,
    ManageAMPSubscriptionScheduledComponent,
    ConfirmUpgradeComponent,
    ConfirmRenewalComponent,
    BudgetAndAlertsComponent,
    BudgetAndAlertsDetailsComponent,
    BudgetAndAlertsEditComponent,
    AMPSubscriptionCancellationComponent,
    ManageAzureSubscriptionComponent,
    MASSubscriptionsComponent,
    CSPEndUserDetailsComponent,
    WGSEndUserDetailsComponent,
    AMPCustomerDetailsComponent,
    CSPTenantManagementComponent,
    WGSTenantManagementComponent,
    CSPEndUserPortalManagementComponent,
    CSPLicenseSubscriptionComponent,
    ManageReservedInstanceComponent,
    ManageCirrusComponent,
    ManageCirrusDetailsComponent,
    EditCirrusEndUserComponent,
    CreateCirrusEndUserComponent,
    EditCirrusPaymentComponent,
    AddCirrusSubscriptionComponent,
    BulkTransferComponent
  ],

  providers: [
    SharedService,
    ManageService,
    AdobeService,
    DialogService,
    CanDeactivateGuard,
    PendingChangesGuard,
    CspTransitionSkuPipe
  ],

  entryComponents: [
    MicrosoftCloudAgreementComponent,
    ConfirmSplaOrderComponent,
    AddAddonComponent,
    ConfigureEndUserComponent
  ],
})
export class ManageSubscriptionsModule {
}
